import { render, staticRenderFns } from "./ScreenChart.vue?vue&type=template&id=20024760&scoped=true&"
import script from "./ScreenChart.vue?vue&type=script&lang=js&"
export * from "./ScreenChart.vue?vue&type=script&lang=js&"
import style0 from "./ScreenChart.vue?vue&type=style&index=0&id=20024760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20024760",
  null
  
)

export default component.exports